(function () {
    'use strict';

    var from, to,
        queryString = location.search;

    // check querystring for to/from dates
    if (queryString.length) {
        var qs = queryString.substr(1, queryString.length).split('&');
        angular.forEach(qs, function (q) {
            var kvp = q.split('=');
            if (kvp[0] === 'from') {
                from = parseInt(kvp[1]);
            } else {
                to = parseInt(kvp[1]);
            }
        });
    }

    function assignmentCalcController($scope, $filter, $timeout) {

        var vm = angular.extend(this, {
            deadline: deadline,
            today: new Date(),
            oneDay: 864e5,
            message: '',            
            messages: [],

            getMessages: getMessages,
            clear: clear,
            export: exportAsIcs
        });

        // set history state to preserve page on navigation
        var body = angular.element(document.querySelector('body')[0]);

        body.find('.sidebar a').on('click', function () {
            var href = location.href.substr(0, location.href.indexOf('?'));
            history.replaceState(null, null, href + '?to=' + vm.toDate.getTime() + '&from=' + vm.fromDate.getTime());
        });

        function clear() {
            $scope.$broadcast('clear');
        };

        function getMessages() {
            var m = angular.element(document.querySelectorAll('.message-list li'));
            angular.forEach(m, function (li) {
                vm.messages.push({
                    from: li.dataset.from,
                    to: li.dataset.to,
                    text: li.innerText
                });
            });
        };

        function getDays() {

            vm.diffDays = Math.round(Math.abs((vm.toDate.getTime() - vm.fromDate.getTime()) / (vm.oneDay)));

            var m = $filter('filter')(vm.messages, function (v) {
                return v.from <= vm.diffDays && vm.diffDays <= v.to;
            })[0];

            vm.message = m ? m.text : '';
        };

        function deadline(p) {
            if (vm.diffDays) {
                var stepSize = (p / 100) * vm.diffDays;
                return 'Complete by ' + $filter('date')(new Date(vm.fromDate.getTime() + (vm.oneDay * stepSize)), 'd MMMM');
            }
            return null;
        };
        

        $scope.$on('dateChange', function(e, data) {
            if (data.type) {
                if (data.type === 'from') {
                    vm.fromDate = data.date;
                } else {
                    vm.toDate = data.date;
                }

                if (vm.toDate && vm.fromDate) {
                    if (vm.fromDate <= vm.toDate) {
                        getDays();
                    } else if (vm.toDate < vm.fromDate) {
                        vm.message = 'Really? What are you, some sort of timetravelling robot?';
                        vm.diffDays = '';
                    }
                }
            } else {
                vm.fromDate = vm.toDate = data.date;
                vm.message = '';
                vm.diffDays = '';
            }

        });

        /** export as ICS file **/
        function exportAsIcs() {
            var icsHeader = `BEGIN:VCALENDAR\r\nVERSION:2.0\r\nPRODID:-//UniSC//NONSGML v1.0//EN\r\nX-WR-CALNAME:${vm.assignmentName}\r\n`,
                icsBody = '',
                icsMsg;

            // items are server-rendered, so need to get all data from the dom
            const steps = document.querySelectorAll('.calc-step:not(.last-step)');
            Array.from(steps).forEach((step, i) => {
                var stepSize = (parseInt(step.dataset.deadline, 10) / 100) * vm.diffDays;
                var date = new Date(vm.fromDate.getTime() + (vm.oneDay * stepSize));
                var startDate = $filter('date')(date, 'yyyyMMdd') + 'T000000';
                var endDate = $filter('date')(date.setDate(date.getDate() + 1), 'yyyyMMdd') + 'T000000';

                let icsEvent = `BEGIN:VEVENT\r\nUID:${i}_${vm.assignmentName}_usc-assignment-calculator\r\nDTSTART;VALUE=DATE:${startDate}\r\nDTEND;VALUE=DATE:${endDate}`;
                icsEvent += `\r\nSUMMARY:Step ${i + 1}: ${step.querySelector('h5').innerText}\r\nSTATUS:CONFIRMED\r\nEND:VEVENT\r\n`;

                icsBody += icsEvent;                
            });

            icsMsg = icsHeader + icsBody + 'END:VCALENDAR';

            if (!navigator.userAgent.match(/msie|trident/i)) {

                var downloadLink = document.createElement("a");
                downloadLink.href = 'data:text/calendar;charset=utf-8,\r\n' + escape(icsMsg);
                downloadLink.download = `${vm.assignmentName || 'calendar'}.ics`;
                //when an event is triggered programmatically which already exists in the client side, it calls $apply within $digest for the second time
                // which causing Action Already In Progress error. 
                //To avoid this we need to move the call to event outside of the digest, by using $timeout(fn, 0, false)
                //refer to https://docs.angularjs.org/error/$rootScope/inprog?p0=$apply
                $timeout(function () {
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    document.body.removeChild(downloadLink);
                }, 0, false);

            }
            else {
                var blob = new Blob([icsMsg]);
                window.navigator.msSaveOrOpenBlob(blob, `${vm.assignmentName || 'calendar'}.ics`);
            }
        }     
    };

    function dateController($scope) {

        var vm = this;

        angular.extend(vm, {

            dateOptions: {
                formatYear: 'yy',
                formatDay: 'd',
                startingDay: 0,
                showWeeks: false
            },
            format: 'd MMMM yyyy',

            today: function () {
                this.dt = new Date();
            },
            clear: function () {
                this.dt = null;
                $scope.$emit('dateChange', { type: null, date: this.dt });
            },
            open: function ($event) {
                $event.preventDefault();
                $event.stopPropagation();
                this.opened = true;
            },
            selectDate: function (type) {
                $scope.$emit('dateChange', { type: type, date: this.dt });
            },
            init: function (type) {
                if (to || from) {
                    this.dt = new Date(type === 'to' ? to : from);                    
                    this.selectDate(type);
                }
            }
        });
        
        this.today = new Date();

        $scope.$on('clear', function () {
            vm.clear();
        });
    };

    // inject!
    angular.module('Uscapp')
        .controller('assignmentCalcCtrl', ['$scope', '$filter', '$timeout', assignmentCalcController])
        .controller('dateCtrl', ['$scope', '$filter', dateController]);
})();